// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import filtersReducer from './filters/filtersSlice'; // Use the non-persisted reducer
import favoritesReducer from './favorites/favoritesSlice'; // Import the favorites slice

// Creating store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    filters: filtersReducer, // Use the filters reducer directly
    favorites: favoritesReducer, // Add the favorites reducer here
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disabling serializable checks for non-serializable data
    }),
  devTools: process.env.NODE_ENV !== 'production', // Disable Redux DevTools in production
});
